export const firebaseConfig = {
    apiKey: "AIzaSyC4ePbvn9mohj72IhRs-z0VEfVjuPYgrfs",
    authDomain: "myterritory-1540955012124.firebaseapp.com",
    databaseURL: "https://myterritory-1540955012124.firebaseio.com",
    projectId: "myterritory-1540955012124",
    storageBucket: "myterritory-1540955012124.appspot.com",
    messagingSenderId: "793794914676",
    appId: "1:793794914676:web:e1eddcdc6ab788f7316421"
};